import React, { Fragment } from 'react';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import QrReader from '@components/QrReader';
import cn from 'classnames';
import Button from '@formElements/Button';

const QrScanComp = ({
  handleError,
  handleScan,
  code,
  handleCancel,
  sensorReg,
  setScanCode,
}) => (
  <Fragment>
    <div className="position-fixed text-primary od-text-primary fs-24" style={{ top: '0px', right: '5px', zIndex: '999' }}><i role="presentation" className="fa fa-times" aria-hidden="true" onClick={() => handleCancel()} /></div>
    <div className={cn('col-12 od-text-primary text-primary text-center')}>
      {CUSTOM_MESSAGES().QR_CODE_MESSAGE}
    </div>
    <div className={cn('d-flex mt-2 flex-column col-lg-4 offset-lg-4 col-sm-12 col-md-6 offset-md-3')}>
      <QrReader
        onError={handleError}
        onScan={handleScan}
        style={{ width: '100%' }}
      />
    </div>
    {code && (
      <div className={cn('d-flex flex-column col-lg-6 offset-lg-3 col-sm-12 col-md-6 offset-md-3')}>
        <div className="px-3 mt-2 fs-26 text-center fw-600">
          Code: {code}
        </div>
      </div>
    )}
    {sensorReg && code && (
      <div className={cn('d-flex flex-column col-lg-4 offset-lg-4 col-sm-12 col-md-6 offset-md-3 mb-60')}>
        <Button type="button" onClick={() => { sensorReg({ externalId: code }); setScanCode(null); }} className="btn btn-primary btn-ripple od-btn-primary col-4 offset-4">
          <Fragment>{LABEL.SAVE}</Fragment>
          loading
        </Button>
      </div>
    )}
  </Fragment>
);

export default QrScanComp;
